<template>
  <div v-if="access !== null">
    <!-- <EditKategoriSOSPopUp :activate="active" @callback="callBackPopUp" @withClose="loadData" :passData="passData" />
    <SubKategoriSOSPopup v-if="passSubmenu !== null" :activate="activeSubmenu" @callback="callBackSubmenu" @withClose="loadData" :passData="passSubmenu" ></SubKategoriSOSPopup> -->
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <header class="w-full">
        <div class="mb-base mt-4 vx-row justify-between items-top">
          <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
            <span class="text-black text-2xl">Tabel Campaign</span>
          </section>
          <!-- <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end">
            <vs-button @click="toAdd" v-if="access.create === 1"
              >Tambah Campaign</vs-button
            >
          </section> -->
        </div>
        <div class="vx-row justify-between items-center">
          <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="dialogDelete" v-if="access.delete === 1">
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="vx-row justify-end items-center">
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full lg:mr-0"
                v-model="aproval"
                :reduce="(v) => v.id"
                :options="[
                  {
                    id: 1,
                    text: 'Aproved',
                  },
                  {
                    id: 0,
                    text: 'Un-aproved',
                  },
                ]"
                label="text"
                placeholder="Status Aproval"
              />
              <v-select
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="urgensitas"
                :reduce="(v) => v.id"
                :options="[
                  {
                    id: 0,
                    text: 'Normal',
                  },
                  {
                    id: 1,
                    text: 'Darurat',
                  },
                ]"
                label="text"
                placeholder="Urgensitas"
              />
              <vs-input
                class="vx-col lg:w-1/3 md:w-1/3 sm:w-full"
                v-model="search"
                placeholder="Cari Judul Campaign"
              />
            </div>
          </section>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div
          class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
        ></div>
      </header>

      <main ref="loadCampaign">
        <vs-table stripe :data="campaigns" v-model="selected" :max-items="limit">
          <template slot="thead">
            <vs-th>Cover</vs-th>
            <vs-th>Judul</vs-th>
            <vs-th>User/Mitra</vs-th>
            <vs-th>Masa AKtif</vs-th>
            <vs-th>Target Donasi</vs-th>
            <vs-th>Aproval</vs-th>
            <vs-th>Aksi</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].file">
                <img
                  key="indextr"
                  :src="
                    data[indextr].file
                      ? data[indextr].file.includes('http')
                        ? data[indextr].file
                        : `${url.baseFl}/${data[indextr].file}`
                      : emptyImage
                  "
                  alt="user-img"
                  class="rounded-lg shadow-md cursor-pointer block"
                />
              </vs-td>
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].user">
                {{ data[indextr].user ? data[indextr].user.name : "(User Kosong)" }}
              </vs-td>

              <vs-td>
                {{ `${data[indextr].mulai} - ${data[indextr].selesai}` }}
              </vs-td>
              <vs-td :data="data[indextr].donasi">
                {{ data[indextr].donasi | toCurrency }}
              </vs-td>
              <vs-td :data="data[indextr].status">
                <span
                  :style="data[indextr].status === 1 ? 'color: green;' : 'color: red;'"
                >
                  {{ data[indextr].status === 1 ? "Aproved" : "Un-Aproved" }}
                </span>
              </vs-td>
              <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="toAprove(data[indextr].id)"
                  >
                  </vs-button>
                  <!-- <vs-button
                    color="warning"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-info"
                    @click="toDetail(data[indextr].id)"
                  >
                  </vs-button> -->
                  <vs-button
                    v-if="access.delete === 1"
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </main>
      <footer>
        <div class="justify-end mt-2">
          <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
        </div>
      </footer>
    </vx-card>
  </div>
</template>

<script>
import EditKategoriSOSPopUp from "@/views/sos/component/EditKategoriSOSPopUp.vue";
import SubKategoriSOSPopup from "@/views/sos/component/SubKategoriSOSPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";
import { parse } from "vue-currency-input";

export default {
  components: {
    SubKategoriSOSPopup,
    EditKategoriSOSPopUp,
    emptyImage,
  },
  data() {
    return {
      url,
      params: {},
      pagination: {
        start: 0,
        length: parseInt(limitDataTables[0]),
      },
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeSubmenu: false,
      passSubmenu: null,
      passData: null,
      aproval: null,
      selected: [],
      urgensitas: null,
      access: null,
      currentPg: 1,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      campaigns: [],
      search: "",
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    totalPage() {
      let pages = this.$store.state.campaign.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
    filters() {
      return {
        search: this.search,
        urgensi: this.urgensitas,
        aproval: this.aproval,
      };
    },
  },
  watch: {
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    filters: {
      handler(val) {
        let searchObj = {};
        let urgensiObj = {};
        let aprovalObj = {};

        if (val.search !== "") {
          searchObj = {
            search: this.search,
            filter: "name",
          };
        } else {
          searchObj = {};
        }

        if (val.urgensi !== null) {
          urgensiObj = {
            status_priority: this.urgensitas,
          };
        } else {
          urgensiObj = {};
        }

        if (val.aproval !== null) {
          aprovalObj = {
            status: this.aproval,
          };
        } else {
          aprovalObj = {};
        }

        this.params = { ...searchObj, ...urgensiObj, ...aprovalObj };
        this.getData();
      },
      deep: true,
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push(`/dashboard/campaign/${id}/detail`).then(() => {});
    },
    toAprove(id) {
      this.$router.push(`/dashboard/campaign/${id}/aprove`).then(() => {});
    },
    toAdd() {
      this.$router.push("/dashboard/campaign/add").then(() => {});
    },
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadCampaign,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("campaign/cudCampaign", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Campaign ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadCampaign);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getKategori() {
      this.$store.dispatch("campaign/getKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    getSubKategori() {
      this.$store.dispatch("campaign/getSubKatCampaign", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadCampaign,
        color: "primary",
      });
      let idData = {};
      if (this.profile !== null || this.profile !== undefined) {
        if (this.profile.level.id !== 2) {
          idData = {
            user_id: this.profile.id,
          };
        }
      } else {
        this.$vs.notify({
          position: "top-right",
          title: "Oops!",
          text: "User tidak ditemukan",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      this.$store
        .dispatch("campaign/getCampaign", {
          ...this.params,
          ...idData,
          ...this.pagination,
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadCampaign);
          this.campaigns = v.data.filter(
            (v) => v.user !== null && v.sub_kategori !== null
          );
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadCampaign);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.getKategori();
    this.getSubKategori();
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/campaign"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/campaign"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
